import { CatalogFeedbackListRequest, CatalogFeedbackListResponse } from '@common/model/catalog/feedback/list.request';
import { coreApi } from '@cp/shared/api/core';

type CatalogFeedbackListResponsePaged = CatalogFeedbackListResponse & { page: number };

export const coreCatalogFeedbacksApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getList: builder.query<CatalogFeedbackListResponsePaged, CatalogFeedbackListRequest>({
      query: (params) => {
        return {
          url: '/catalog/feedbacks',
          params,
        };
      },
      transformResponse: (
        response: CatalogFeedbackListResponse,
        _,
        { page = 1 }: CatalogFeedbackListRequest,
      ): CatalogFeedbackListResponsePaged => {
        return { page, ...response };
      },
    }),
  }),
});
